import styled from 'styled-components';
const MemberDetailStyled = styled.div`
  background-color: #fff;
  height: 100%;
  padding: 40px 80px;
  padding-bottom: 32px;
  .text-detail-info {
    .Mui-disabled {
      .text-detail-label {
        color: #212121;
      }
      .text-detail-info {
        color: #212121;
      }
      .css-8sgtit-MuiInputBase-input-MuiInput-input.Mui-disabled {
        -webkit-text-fill-color: #212121;
      }
    }
  }

  form {
    height: 100%;
  }
  .load {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .row {
    display: flex;
    justify-content: end;
    .MuiBox-root {
      height: 20px;
    }
    .MuiFormControl-marginNormal {
      margin: 0;
    }
    > div {
      width: 33.3333%;
    }
    .address {
      margin-right: 48px;
    }
  }
  .text-detail-info {
    input {
      height: 23px;
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      line-height: 27px;
    }
    .MuiInputBase-root-MuiInput-root::after {
      border: none;
    }
    .MuiInputBase-root-MuiInput-root:hover:not(.Mui-disabled):before {
      border: none;
    }
  }
  .text-detail-label {
    height: 21px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.54);
    line-height: 21px;
  }
  .detail-title {
    margin-bottom: 27px;
    height: 32px;
    font-size: 21px;
    font-weight: 500;
    color: #212121;
    line-height: 31px;
  }
  .mulSelect {
    display: flex;
    .checkbox-radio-disabled-color {
      color: darkgray;
    }
    .Mui-disabled {
      color: darkgray;
    }
    /* border: 1px solid red; */
  }
`;
export default MemberDetailStyled;
